import React, { Component } from 'react';
import { Header, Container, Card, Image } from 'semantic-ui-react';

class MemberQuotes extends Component {
  render() {
    const { tittel, medlemsreferanser } = this.props;
    return (
      <Container>
        <Header as="h1" id="medlemsreferanser">
          <span dangerouslySetInnerHTML={{ __html: tittel }} />
        </Header>
        <Card.Group stackable itemsPerRow={2} className="medlemsreferanser">
          {medlemsreferanser.map(
            ({ medlemsnavn, medlemsnummerUrl, bilde, sitat, navn }, index) => (
              <Card key={`quote-${index}`}>
                <Image src={bilde} className="ui fluid" />
                <Card.Content>
                  <Card.Header>{navn}</Card.Header>
                  <Card.Meta>fra {medlemsnavn}</Card.Meta>
                  <Card.Description>
                    {(typeof sitat === 'string' ? [sitat] : sitat).map(
                      (paragraph, idx) => (
                        <p key={`quote-par-${idx}`}>{paragraph}</p>
                      )
                    )}
                  </Card.Description>
                </Card.Content>
              </Card>
            )
          )}
        </Card.Group>
      </Container>
    );
  }
}

export default MemberQuotes;



// WEBPACK FOOTER //
// ./src/LandingPage/MemberQuotes.js